/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import {
    ColumnFieldType,
    EColumnCell,
    EColumnFilter,
    TableFooterColumnFieldType,
} from '../../../components/Table/types/columnTypes';

export enum EPagePaymentsTableField {
    account = 'account',
    amount = 'amount',
    msisdn = 'msisdn',
    operationDate = 'operationDate',
    paymentDocument = 'paymentDocument',
    paymentSource = 'paymentSource',
    paymentType = 'paymentType',
}

export const PagePaymentsTableColumnNames: EPagePaymentsTableField[] = [
    EPagePaymentsTableField.operationDate,
    EPagePaymentsTableField.paymentType,
    EPagePaymentsTableField.amount,
    EPagePaymentsTableField.account,
    EPagePaymentsTableField.msisdn,
    EPagePaymentsTableField.paymentDocument,
    EPagePaymentsTableField.paymentSource,
];

export type TPagePaymentsTableData = { [F in EPagePaymentsTableField]: string };

export const PagePaymentsTableCellConfig = {
    [EPagePaymentsTableField.account]: 170,
    [EPagePaymentsTableField.amount]: 150,
    [EPagePaymentsTableField.msisdn]: 170,
    [EPagePaymentsTableField.operationDate]: 190,
    [EPagePaymentsTableField.paymentDocument]: 170,
    [EPagePaymentsTableField.paymentSource]: 170,
    [EPagePaymentsTableField.paymentType]: 180,
};

export const getPagePaymentsTableColumnFilterType = (name: string) => {
    switch (name) {
        case EPagePaymentsTableField.account:
        case EPagePaymentsTableField.paymentType:
            return EColumnFilter.filterMultiSelect;

        case EPagePaymentsTableField.amount:
            return EColumnFilter.filterRange;

        case EPagePaymentsTableField.operationDate:
            return EColumnFilter.filterDate;

        case EPagePaymentsTableField.paymentDocument:
        case EPagePaymentsTableField.msisdn:
            return EColumnFilter.filterSearchInput;

        default:
            return '';
    }
};

export const getPagePaymentsTableColumnCellType = (name: EPagePaymentsTableField) => {
    switch (name) {
        case EPagePaymentsTableField.account:
            return EColumnCell.linkAccountNumber;

        case EPagePaymentsTableField.amount:
            return EColumnCell.amount;

        case EPagePaymentsTableField.operationDate:
            return EColumnCell.createDate;

        case EPagePaymentsTableField.msisdn:
        case EPagePaymentsTableField.paymentDocument:
        case EPagePaymentsTableField.paymentType:
        case EPagePaymentsTableField.paymentSource:
        default:
            return EColumnCell.text;
    }
};

export enum EPagePaymentsTableFooterField {
    amount = 'amountTotal',
}

export const MapPagePaymentFieldToFooter: { [key in ColumnFieldType]?: TableFooterColumnFieldType } = {
    [EPagePaymentsTableField.amount]: EPagePaymentsTableFooterField.amount,
};
